import { Permission, PermissionGroupId, PermissionGroupIds, PermissionGroups } from "..";

export const permissionGroupHelper = 
{
    hasMinimumPermissionGroup,
    hasPermission
}

function hasMinimumPermissionGroup(user:PermissionGroupId, required:PermissionGroupId) {
    const userIndex = PermissionGroupIds.findIndex(p => p === user);
    const requiredIndex = PermissionGroupIds.findIndex(p => p === required);
    return userIndex >= requiredIndex;
}



function hasPermission(permissionGroupId:PermissionGroupId, required:Permission) {
    const group = PermissionGroups.all.find(g => g.id === permissionGroupId);
    if(!group)
        return false;
    return group.permissions.find(p => p===required) !== undefined;
}
